import { ReactElement, useMemo } from "react";
import { IntegrationFlowListItem } from "../../../Items/IntegrationFlowListItem";
import { TimeZone } from "client/DateAndTime/timezones";
import { convertAppColor, convertAppImage } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { AppColorViewModel } from "client/Api/Apps/common";
import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import { generateTrackingId } from "client/Misc/utils";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { useIntegrationFlowNavigationHandler } from "../../../Navigation/useIntegrationFlowNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type IntegrationFlowItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.IntegrationFlow>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	tabIndex: number;
};

export const IntegrationFlowItemView = (props: IntegrationFlowItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		title,
		dateTime,
		subTitle1,
		subTitle2,
		color: persistedColor,
		icon: persistedIcon,
		link
	} = item.integrationFlow;

	const openHandler: () => void = useIntegrationFlowNavigationHandler({
		link,
		recentlyOpenedItem: item
	});

	const color = useMemo(
		(): AppColorViewModel => convertAppColor(persistedColor),
		[persistedColor]
	);

	const icon = useMemo(
		(): AppImageDisplayInfo => convertAppImage(persistedIcon),
		[persistedIcon]
	);

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("integration-flow-item", `|${itemIndex}`)}
			onClick={openHandler}
		>
			<IntegrationFlowListItem
				title={title}
				dateTime={dateTime}
				subTitle1={subTitle1}
				subTitle2={subTitle2}
				color={color}
				icon={icon}
				timezone={timezone}
				onRemove={onRemove}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
IntegrationFlowItemView.displayName = "IntegrationFlowItemView";